
import { submitFormToNetlifyFunction } from './api-client';
import { parseNetlifyFunctionResponse } from './response-parser';

/**
 * Handles form submission using Supabase function without reCAPTCHA
 */
export const verifyRecaptchaAndSubmit = async (formData: Record<string, any>) => {
  try {
    console.log('Submitting form data...', {
      formDataKeys: Object.keys(formData),
      formType: formData.formType
    });
    
    const response = await submitFormToNetlifyFunction(formData);
    return await parseNetlifyFunctionResponse(response);
  } catch (error) {
    console.error('Error submitting form:', error);
    throw error;
  }
};

/**
 * Prepares form data for submission with additional tracking information
 */
export const prepareFormData = (formData: Record<string, any>, formType: 'contact' | 'booking') => {
  const formTypeMap = {
    contact: 'Website Contact Form',
    booking: 'Website Booking Request'
  };

  // Additional form data for tracking
  return {
    ...formData,
    formType: formTypeMap[formType] || formTypeMap.contact,
    source: window.location.href,
    timestamp: new Date().toISOString(),
  };
};
